import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Badge } from "@/shared/ui/badge";
import { AlertTriangle, CheckCircle, XCircle, Clock } from "lucide-react";

export function QualityOverviewWidget() {
  const qualityData = {
    openIssues: 12,
    criticalIssues: 3,
    resolvedToday: 8,
    avgResolutionTime: "4.2h",
    recentIssues: [
      { id: "QI-2024-0045", severity: "high", status: "open", line: "Assembly Line 2" },
      { id: "QI-2024-0044", severity: "medium", status: "in_progress", line: "Paint Shop 1" },
      { id: "QI-2024-0043", severity: "low", status: "resolved", line: "Final Inspection" },
    ],
  };

  const severityColor = {
    high: "text-destructive",
    medium: "text-warning",
    low: "text-chart-2",
  };

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <AlertTriangle className="h-4 w-4" />
          Quality Overview
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 space-y-4">
        <div className="grid grid-cols-4 gap-2">
          <div className="text-center p-2 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Open</p>
            <p className="text-xl font-bold">{qualityData.openIssues}</p>
          </div>
          <div className="text-center p-2 bg-destructive/10 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Critical</p>
            <p className="text-xl font-bold text-destructive">{qualityData.criticalIssues}</p>
          </div>
          <div className="text-center p-2 bg-success/10 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Resolved</p>
            <p className="text-xl font-bold text-success">{qualityData.resolvedToday}</p>
          </div>
          <div className="text-center p-2 bg-muted/50 rounded-lg">
            <p className="text-xs text-muted-foreground mb-1">Avg Time</p>
            <p className="text-xl font-bold">{qualityData.avgResolutionTime}</p>
          </div>
        </div>

        <div className="space-y-2">
          <p className="text-xs font-medium text-muted-foreground">Recent Issues</p>
          {qualityData.recentIssues.map((issue) => (
            <div key={issue.id} className="flex items-center justify-between p-2 bg-muted/30 rounded-md text-xs">
              <div className="flex items-center gap-2">
                {issue.status === "resolved" && <CheckCircle className="h-3 w-3 text-success" />}
                {issue.status === "in_progress" && <Clock className="h-3 w-3 text-warning" />}
                {issue.status === "open" && <XCircle className="h-3 w-3 text-destructive" />}
                <span className="font-mono">{issue.id}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground">{issue.line}</span>
                <Badge variant="outline" className={`text-xs ${severityColor[issue.severity as keyof typeof severityColor]}`}>
                  {issue.severity}
                </Badge>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
